enum SignatureSettings {
  TYPE_SIGNATURE = 'type-signature',
  MANUAL = 'manual',
}

export default SignatureSettings;
